import { render, staticRenderFns } from "./FilteredImage.vue?vue&type=template&id=6f06cc72"
import script from "./FilteredImage.vue?vue&type=script&lang=js"
export * from "./FilteredImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports